const inputs = document.querySelectorAll('#product-detail-input-quantity')
const openCartButton = document.getElementById('cart-button-open')
const variantId = document.getElementById('product-detail-variant-id')?.value
const id = document.getElementById('product-detail-id')?.value
const stock = Number(document.getElementById('product-detail-stock')?.value)
// const key = document.getElementById('product-detail-key').value
// const count = document.getElementById('product-detail-count').value
const plusButtons = document.querySelectorAll('#product-detail-plus-button')
const minusButtons = document.querySelectorAll('#product-detail-minus-button')
const submitButtons = document.querySelectorAll('#product-detail-submit-button')
const customButton = document.querySelector('.Product-Button-Custom')
const pluginButton = document.querySelector('.Product-Button-Plugin')
const quantityInputs = document.querySelectorAll('quantity-input')
const cartBubbleQuantity = document.getElementById('cart-bubble-detail')
const cartBubbleQuantityMobile = document.getElementById('cart-bubble-mobile-detail')

let submitButtonIsActive = false
let items = []
let itemsHasChecked = false
let finalQuantity = 0
let pluginCartInputsWithEvents = []

const handleCartInput = async (e) => {
  // Remove left zeros
  inputs.forEach(input => input.value = e.target.value.replace(/^0+/, ''))

  let currentQuantity = Number(e.target.value)
  if (!itemsHasChecked) {
    const data = await getQuantityCart()
    items = data.items
    itemsHasChecked = true
  }
  const itemInCart = items?.find(item => item.variant_id == variantId)
  const cartQuantity = itemInCart ? itemInCart.quantity : 0
  finalQuantity = itemInCart ? currentQuantity + cartQuantity : currentQuantity

  // Set negative and stock limit
  if (finalQuantity < 1) {
    currentQuantity = 1
    finalQuantity = 1
  }

  if (finalQuantity > stock) {
    currentQuantity = stock - cartQuantity
    finalQuantity = stock
  }

  inputs.forEach(input => input.value = currentQuantity)

  setMinusButtonStatus(currentQuantity)
  setPlusButtonStatus(finalQuantity)
}

const handlePluginCartInputs = async () => {
  const pluginCartTitles = document.querySelectorAll('.amp-cart__cart-line-title')
  const pluginCartInputs = document.querySelectorAll('.amp-cart__line-quantity-selector-input')
  const pluginCartMinusButtons = document.querySelectorAll('.amp-cart__line-quantity-selector-less')
  const pluginCartPlusButtons = document.querySelectorAll('.amp-cart__line-quantity-selector-more')
  const pluginCartRemoveButtons = document.querySelectorAll('.amp-cart__cart-line-remove')

  pluginCartTitles.forEach((element, index) => {
    const title = element.innerHTML
    if (!pluginCartInputsWithEvents.includes(title)) {
      pluginCartInputs[index].addEventListener('input', async () => {
        setTimeout(async () => {
          await checkItemInCart()
        }, 1500)
      })
      pluginCartMinusButtons[index].addEventListener('click', async () => {
        setTimeout(async () => {
          await checkItemInCart()
        }, 1500)
      })
      pluginCartPlusButtons[index].addEventListener('click', async () => {
        setTimeout(async () => {
          await checkItemInCart()
        }, 1500)
      })
      pluginCartRemoveButtons[index].addEventListener('click', async () => {
        // Remove title from array
        pluginCartInputsWithEvents = pluginCartInputsWithEvents.filter(item => item !== title)

        setTimeout(async () => {
          await checkItemInCart()
        }, 1500)
      })
      pluginCartInputsWithEvents.push(title)
    }
  })

  // checkAllItemsInCart()
}

const checkItemInCart = async (e) => {
  const data = await getQuantityCart()
  items = data.items
  itemsHasChecked = true
  const itemInCart = items?.find(item => item.variant_id == variantId)

  if (itemInCart) {
    let currentQuantity = Number(inputs[0].value)
    const cartQuantity = itemInCart.quantity
    finalQuantity = itemInCart ? cartQuantity : currentQuantity

    // Set negative and stock limit
    if (finalQuantity < 1) {
      currentQuantity = 1
      finalQuantity = 1
    }

    if (finalQuantity > stock) {
      currentQuantity = stock - cartQuantity
      finalQuantity = stock
    }

    setSubmitButtonStatus(finalQuantity)
    setMinusButtonStatus(currentQuantity)
    setPlusButtonStatus(finalQuantity + currentQuantity)
  }

  if (data.count === 0) {
    cartBubbleQuantity.classList.add('d-none')
    cartBubbleQuantityMobile.classList.add('d-none')
  } else {
    cartBubbleQuantity.classList.remove('d-none')
    cartBubbleQuantity.innerText = data.count

    cartBubbleQuantityMobile.classList.remove('d-none')
    cartBubbleQuantityMobile.innerText = data.count
  }
}

// const checkAllItemsInCart = async () => {
//   const pluginCartTitles = document.querySelectorAll('.amp-cart__cart-line-title')
//   const pluginCartInputs = document.querySelectorAll('.amp-cart__line-quantity-selector-input')

//   items.forEach(async (item) => {
//     const response = await fetch(window.Shopify.routes.root + `products/${item.handle}.js`)
//     const data = await response.json()
//   })
// }

const setSubmitButtonStatus = (currentQuantity) => {
  if (currentQuantity === stock) {
    quantityInputs.forEach(input => input.classList.add('d-none'))
    submitButtons.forEach(button => {
      button.disabled = true
      button.title = 'Stock limit'
      button.querySelector('span').innerText = 'STOCK LIMIT'
      button.classList.remove('button-yellow', 'ms-3')
      button.classList.add('button-disabled')
    })
  } else {
    quantityInputs.forEach(input => input.classList.remove('d-none'))
    submitButtons.forEach(button => {
      button.disabled = false
      button.title = 'Add to cart'
      button.querySelector('span').innerText = 'ADD TO CART'
      button.classList.remove('button-disabled')
      button.classList.add('button-yellow', 'ms-3')
    })
  }
}

const setMinusButtonStatus = (currentQuantity) => {
  if (currentQuantity === 1) {
    minusButtons.forEach(button => {
      button?.classList?.remove('Product__Quantity-Button')
      button?.classList?.add('Product__Quantity-Button-Disabled')
      button.setAttribute("disabled", true)
      button.setAttribute("title", 'Minimum Limit')
    })
  } else {
    minusButtons.forEach(button => {
      button?.classList?.add('Product__Quantity-Button')
      button?.classList?.remove('Product__Quantity-Button-Disabled')
      button.removeAttribute("disabled")
      button.removeAttribute("title")
    })
  }
}

const setPlusButtonStatus = (currentQuantity) => {
  if (currentQuantity === stock) {
    plusButtons.forEach(button => {
      button?.classList?.remove('Product__Quantity-Button')
      button?.classList?.add('Product__Quantity-Button-Disabled')
      button.setAttribute("disabled", true)
      button.setAttribute("title", 'Stock Limit')
    })
  } else {
    plusButtons.forEach(button => {
      button?.classList?.add('Product__Quantity-Button')
      button?.classList?.remove('Product__Quantity-Button-Disabled')
      button.removeAttribute("disabled")
      button.removeAttribute("title")
    })
  }
}


inputs?.forEach(item => {
  item?.addEventListener('input', handleCartInput)
})
inputs?.forEach(item => {
  item?.addEventListener('change', handleCartInput)
})

openCartButton?.addEventListener('click', async (e) => {
  e.preventDefault()
  itemsHasChecked = false
})


const submitButtonObserver = new MutationObserver((mutationsList, observer) => {
  if (submitButtons[0]?.parentNode !== null && !submitButtonIsActive) {
    // Plugin cart
    if (window.upcartModifyCart) {
      pluginButton?.classList?.remove('d-none')
      submitButtons.forEach(button => {
        button?.addEventListener('click', async (e) => {
          e.preventDefault()
          e.stopPropagation()
          window.upcartModifyCart()
          setSubmitButtonStatus(finalQuantity)
          if (finalQuantity === 0) {
            cartBubbleQuantity.classList.add('d-none')
            cartBubbleQuantityMobile.classList.add('d-none')
          } else {
            cartBubbleQuantity.classList.remove('d-none')
            cartBubbleQuantity.innerText = finalQuantity

            cartBubbleQuantityMobile.classList.remove('d-none')
            cartBubbleQuantityMobile.innerText = finalQuantity
          }
        })
      })

      submitButtonIsActive = true

      observer.disconnect();
      return
    }

    // Custom cart
    customButton?.classList?.remove('d-none')
    submitButtons.forEach(button => {
      // button?.addEventListener('click', async (e) => {
      //   e.preventDefault()
      //   e.stopPropagation()
      //   const currentQuantity = Number(inputs[0]?.value) || 1
      //   const stock = Number(inputs[0]?.dataset?.stock) || 1
      //   const currentVariantId = variantId || button.dataset['productId']

      //   const { count, items, subtotal } = await getQuantityCart()
      //   const itemInCart = items.find(item => item.id == currentVariantId)

      //   if (!itemInCart) {
      //     const { items, itemPrice } = await addCartItem(currentVariantId, currentQuantity, count, stock)
      //     const newSubtotal = subtotal + itemPrice

      //     await setCartItems(items[0], newSubtotal)

      //     openCartOverlay()
      //   } else {
      //     const { data, subtotal } = await updateCartItem(currentVariantId, currentQuantity, itemInCart.quantity)

      //     data.items.forEach((item) => {
      //       setCartItems(item, subtotal)
      //     })

      //     openCartOverlay()
      //   }

      //   inputs.forEach(input => input.value = 1)
      //   setSubmitButtonStatus(finalQuantity)
      //   if (finalQuantity === 0) {
      //     cartBubbleQuantity.classList.add('d-none')
      //     cartBubbleQuantityMobile.classList.add('d-none')
      //   } else {
      //     cartBubbleQuantity.classList.remove('d-none')
      //     cartBubbleQuantity.innerText = finalQuantity

      //     cartBubbleQuantityMobile.classList.remove('d-none')
      //     cartBubbleQuantityMobile.innerText = finalQuantity
      //   }
      //   handlePluginCartInputs()
      // })
    })

    submitButtonIsActive = true

    observer.disconnect();
  }
});

const pluginInputsObserver = new MutationObserver((mutationsList, observer) => {
  const newPluginCartInputs = document.querySelectorAll('.amp-cart__line-quantity-selector-input')

  if (newPluginCartInputs.length > 0) {
    handlePluginCartInputs()

    observer.disconnect();
  }
});


window.addEventListener('DOMContentLoaded', async () => {
  // Configurar y empezar la observación de mutaciones
  checkItemInCart()
  submitButtonObserver.observe(document.documentElement, { childList: true, subtree: true });
  pluginInputsObserver.observe(document.documentElement, { childList: true, subtree: true });
})


const productDataContainer = document.querySelector('.Product__Data')

window.addEventListener('scroll', async (e) => {
  if (window.scrollY > productDataContainer.offsetTop) {
    productDataContainer.style.height = 'auto'
  } else {
    const isMobile = window.innerWidth < 992
    if (isMobile) {
      productDataContainer.style.height = 'calc(100vh - 100px)'
    } else {
      productDataContainer.style.height = 'calc(100vh - 137px)'
    }
  }
})